import {
  takeEvery, call, put, all, delay,
} from 'redux-saga/effects';
import { toast } from 'react-toastify';
import firebase from '../../firebase';
import 'firebase/firestore';

import * as types from '../types';

function* createClientAndPet(action) {
  try {
    const db = firebase.firestore();
    const addClientQuery = db.collection('clients');
    const addPetQuery = db.collection('pets');

    const clientData = {
      name: action.payload.clientName,
      email1: action.payload.clientEmail1 || '',
      email2: action.payload.clientEmail2 || '',
      address: action.payload.clientAddress || '',
      pincode: action.payload.clientPincode || '',
      city: action.payload.clientCity || '',
      state: action.payload.clientState || '',
      phoneR: action.payload.clientPhoneR || '',
      phoneM1: action.payload.clientPhoneM1 || '',
      phoneM2: action.payload.clientPhoneM2 || '',
    };

    const response = yield call(
      [addClientQuery, addClientQuery.add],
      clientData,
    );

    // Need owner id from response
    const petData = {
      owner: response.id,
      ownerName: action.payload.clientName,
      type: action.payload.petType || '',
      name: action.payload.petName || '',
      gender: action.payload.petGender || '',
      breed: action.payload.petType.label === 'Other' ? { value: 0, label: action.payload.petBreed } : action.payload.petBreed || '',
      color: action.payload.petColor || '',
      dob: action.payload.petDob || '',
    };

    // Called after client is added
    const response2 = yield call(
      [addPetQuery, addPetQuery.add],
      petData,
    );

    const updateClientQuery = db.collection('clients').doc(response.id);
    // Add reference to previously created treatment record in firestore
    const check = {
      owned: firebase.firestore.FieldValue.arrayUnion(
        {
          value: response2.id,
          label: action.payload.petName,
        },
      ),
    };

    yield call(
      [updateClientQuery, updateClientQuery.update],
      check,
    );


    yield put({
      type: types.CREATE_CLIENT_AND_PET_SUCCESS,
      payload: {
        createdClientId: response.id,
      },
    });
    yield call(toast.success, 'Created client and pet');

    // on success
    yield delay(500);
    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.CREATE_CLIENT_AND_PET_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}

function* getAllClients(action) {
  try {
    const db = firebase.firestore();
    const getAllClientsQuery = db.collection('clients');

    const querySnapshot = yield call(
      [getAllClientsQuery, getAllClientsQuery.get],
    );

    const clientList = [];
    const pincodeList = [];
    const pincodeList1 = [];
    // let a = '';

    yield all(querySnapshot.docs.map((doc) => {

      // if (doc.data().email2){
      //   a = a + doc.data().email2 + ",";
      // }
      // if (doc.data().email1){
      //   a = a + doc.data().email2 + ",";
      // }

      // console.log(doc.data().email1);
      // Create string from all the array values in owned for each client
      let ownedString = '';
      if (doc.data().owned) {
        ownedString = doc.data().owned.map(e => e.label).join(',');
      }


      if (doc.data().pincode) {
        if (pincodeList.indexOf(doc.data().pincode) === -1) {
          pincodeList.push(doc.data().pincode);
        }
      }

      // Make format compatible with react-select
      return clientList.push({
        value: doc.id,
        label: doc.data().owned ? `${doc.data().name} : ${ownedString}` : doc.data().name,
        pincode: doc.data().pincode,
      });
    }));

    // console.log("FINAL STRING");
    // console.log(a);
    yield all(pincodeList.map(pincode => pincodeList1.push({
      value: pincode,
      label: pincode,
    })));

    yield put({
      type: types.GET_ALL_CLIENTS_SUCCESS,
      payload: {
        clientList,
        pincodeList: pincodeList1,
      },
    });
    yield call(toast.success, 'Got all clients');

    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.GET_ALL_CLIENTS_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}

function* getSingleClient(action) {
  try {
    const db = firebase.firestore();
    const getSingleClientQuery = db.collection('clients').doc(action.payload.id);

    const response = yield call(
      [getSingleClientQuery, getSingleClientQuery.get],
    );

    yield put({
      type: types.GET_SINGLE_CLIENT_DATA_SUCCESS,
      payload: {
        clientData: response.data(),
      },
    });
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.GET_SINGLE_CLIENT_DATA_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}

function* editClientData(action) {
  try {
    const db = firebase.firestore();
    const tempQuery = db.collection('clients').doc(action.payload.id);

    yield call(
      [tempQuery, tempQuery.update],
      action.payload.values,
    );

    yield put({
      type: types.EDIT_CLIENT_DATA_SUCCESS,
      payload: {
        clientData: action.payload,
      },
    });

    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
    yield call(toast.success, 'Updated client data successfully');
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.EDIT_CLIENT_DATA_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}

function* deleteClient(action) {
  try {
    const db = firebase.firestore();
    const tempQuery = db.collection('clients').doc(action.payload.id);

    yield call(
      [tempQuery, tempQuery.delete],
    );

    yield put({
      type: types.DELETE_CLIENT_SUCCESS,
      payload: {
        clientData: action.payload,
      },
    });

    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
    yield call(toast.success, 'Deleted client successfully');
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.DELETE_CLIENT_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}

export default function* () {
  yield takeEvery(types.CREATE_CLIENT_AND_PET_REQUEST, createClientAndPet);
  yield takeEvery(types.GET_ALL_CLIENTS_REQUEST, getAllClients);
  yield takeEvery(types.GET_SINGLE_CLIENT_DATA_REQUEST, getSingleClient);
  yield takeEvery(types.EDIT_CLIENT_DATA_REQUEST, editClientData);
  yield takeEvery(types.DELETE_CLIENT_REQUEST, deleteClient);
}
